import {useEffect, useMemo, useState} from "react";
import PackagePanelContainer from "../PackagePanel/PackagePanelContainer";
import PayPanel from "../PayPanel/PayPanel";
import {useDispatch, useSelector} from "react-redux";
import mainAction from "../../reducer/action/mainAction";
import EndPanel from "../EndPanel/EndPanel";
import FJEvent from "../../lib/FJEvent";
import FJActionConstant from "../../constant/FJActionConstant";

const SubscribeStepContainer = (props) => {
    let {popupType} = props
    let dispatch = useDispatch()
    let {step, selectPage, planData, isAnnually} = useSelector(state => {
        return {
            step: state.mainReducer.step,
            selectPage: state.mainReducer.selectPage,
            planData: state.mainReducer.planData,
            isAnnually: state.mainReducer.isAnnually
        }
    })
    useEffect(() => {
        _hidden()
    }, [step])

    useEffect(() => {
        window.ealog && ealog.addEvent('choose plan page visit', {
            'open page': document.location.pathname,
        });
    }, [])

    let _hidden = () => {
        if (document.getElementById('pricing-view-container')) {
            if (step === 2 || step === 3) {
                document.getElementById('pricing-view-container').style.display = 'none'
            } else {
                document.getElementById('pricing-view-container').style.display = 'block'
            }
        }
    }
    let _changePlan = (value) => {
        window.isAnnually = value
        dispatch(mainAction.updateIsAnnually(value))
    }
    let _changeStep = (stepNum, page) => {
        dispatch(mainAction.changeStepAction(stepNum))
        if (page) {
            window.selectPage = page
            dispatch(mainAction.changeSelectPageAction(page))
        }
    }

    let selectDetail = useMemo(() => {
        let data = {}
        planData.forEach((item) => {
            if (item.package === selectPage) {
                data = item
            }
        })
        return data
    }, [selectPage])
    return (
        <>
            <PackagePanelContainer
                popupType={popupType}
                changeStep={_changeStep}
                isAnnually={isAnnually}
                changePlan={_changePlan}
                active={step === 1}
            />
            {/*{step === 2 && <PayPanel*/}
            {/*    active*/}
            {/*    popupType={popupType}*/}
            {/*    changeStep={_changeStep}*/}
            {/*    changePlan={_changePlan}*/}
            {/*    planDetail={selectDetail}*/}
            {/*    isAnnually={isAnnually}*/}
            {/*/>}*/}
            <PayPanel
                active={step === 2}
                popupType={popupType}
                changeStep={_changeStep}
                changePlan={_changePlan}
                planDetail={selectDetail}
                isAnnually={isAnnually}
            />
            {step === 3 && <EndPanel isAnnually={isAnnually}/>}
        </>
    )
}
export default SubscribeStepContainer